var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 43.6663C21.3309 43.6654 20.6776 43.4464 20.125 43.0378C11.939 37.0174 8.39439 32.8894 6.43929 30.3086C2.27285 24.8073 0.278162 19.1593 0.334409 13.043C0.40003 6.03405 5.59038 0.333008 11.9046 0.333008C16.496 0.333008 19.6761 3.135 21.5281 5.46869C21.5867 5.54187 21.6592 5.60055 21.7406 5.64076C21.822 5.68098 21.9105 5.70179 21.9999 5.70179C22.0894 5.70179 22.1778 5.68098 22.2592 5.64076C22.3406 5.60055 22.4131 5.54187 22.4718 5.46869C24.3238 3.13275 27.5038 0.333008 32.0952 0.333008C38.4095 0.333008 43.5998 6.03405 43.6654 13.0441C43.7217 19.1616 41.7249 24.8096 37.5605 30.3097C35.6054 32.8906 32.0608 37.0185 23.8748 43.0389C23.3221 43.4471 22.6688 43.6658 21.9999 43.6663Z",
    fill: "white",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlur);
export default __webpack_public_path__ + "static/media/heart-blur.69c3552cff040294988eb14847e5a4cf.svg";
export { ForwardRef as ReactComponent };